<template>
  <v-col>
    <v-skeleton-loader
      type="sentences"
      class="my-2 mx-2"
    />
    <v-skeleton-loader
      type="sentences"
      class="my-2 mx-2"
    />
    <v-skeleton-loader
      type="sentences"
      class="my-2 mx-2"
    />
    <v-skeleton-loader
      type="sentences"
      class="my-2 mx-2"
    />
  </v-col>
</template>

<script>
export default {
  name: "RoutesLoading",
};
</script>
